import { Navigate, Outlet } from "react-router-dom";
import { useUserStore } from "../store/userStore";
import { useCanUseSG } from "../hooks/useCanUseSG";
import { useTruckYardRole } from "../hooks/useTruckYardRole";

interface SgAccessProtectedRouteProps {
  allowedRoleIds?: string[];
  restrictedRoles?: string[];
}

export default function SgAccessProtectedRoute({
  allowedRoleIds = [],
  restrictedRoles = [],
}: SgAccessProtectedRouteProps) {
  const user = useUserStore((state) => state.user);
  const { canUseSG } = useCanUseSG();
  const { getDefaultRoute } = useTruckYardRole();

  const userRole = localStorage.getItem("userRole");
  const userRoleId = user?.role_id || localStorage.getItem("userRoleId") || "";

  const roleRestricted =
    restrictedRoles.length > 0 &&
    !!userRole &&
    restrictedRoles.includes(userRole);

  const roleNotAllowed =
    allowedRoleIds.length > 0 &&
    (!userRoleId || !allowedRoleIds.includes(userRoleId));

  if (roleRestricted || roleNotAllowed || !canUseSG) {
    return <Navigate to={getDefaultRoute()} replace />;
  }

  return <Outlet />;
}
